import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import "./styles.css";
import Dropzone from "react-dropzone";
import Excel from "exceljs";
import template from "./kelulusan.xlsx";

function getCookie(cname) {
	let name = cname + "=";
	let decodedCookie = decodeURIComponent(document.cookie);
	let ca = decodedCookie.split(";");
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) == " ") {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

function formatDate(date) {
	var d = new Date(date),
		month = "" + (d.getMonth() + 1),
		day = "" + d.getDate(),
		year = d.getFullYear();

	if (month.length < 2) month = "0" + month;
	if (day.length < 2) day = "0" + day;

	return [year, month, day].join("-");
}

export default function Admin(props) {
	const [submitProgress, setProgress] = useState(false);

	const [items, setItems] = useState([]);

	const controller = useRef();

	const processRow = (row) => {
		const getText = (value) => {
			if (value && typeof value === "object" && value.richText) {
				return value.richText.map((item) => item.text).join("");
			}
			return value || "";
		};

		let result = {
			// nisn: row[1],
			// nama: row[2],
			// jk: row[3],
			// tmp_lahir: row[4],
			// tgl_lahir: formatDate(row[5]),
			// kelas: row[6],
			// jurusan: row[7],
			// lulus: row[8],
			nisn: getText(row[1]),
			nama: getText(row[2]),
			jk: getText(row[3]),
			tmp_lahir: getText(row[4]),
			tgl_lahir: formatDate(row[5]),
			kelas: getText(row[6]),
			jurusan: getText(row[7]),
			lulus: getText(row[8]),
		};

		if (row[9] && row[9].text) {
			result["link"] = row[9].text;
		} else {
			result["link"] = row[9] ? row[9] : "";
		}

		return result;
	};
	const doSubmit = async () => {
		setProgress({
			progress: 0,
			progressCurrent: 1,
			progressTotal: items.length,
		});

		const total = items.length;

		const xitems = items.slice();

		let success = 0;
		let error = 0;

		for (let idx = 0; idx < total; idx++) {
			const data = xitems[idx];

			if (data.hidden_success) continue;

			data.s = "jateng";

			const progress = ((idx + 1) / total) * 100;
			setProgress({ progress, progressCurrent: idx + 1, progressTotal: total });

			try {
				let api_key = getCookie("key");
				const res = await fetch("/_api/skl/submit", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						Authorization: "API-TOKEN api-key=" + api_key,
						// 'Content-Type': 'application/x-www-form-urlencoded',
					},
					body: JSON.stringify(data),
				});

				if (!res.ok) {
					throw new Error("Network response was not OK");
				}
				if (res.status == 401) {
					window.alert("NOT LOGGED IN");
					window.location.href = "/?rd=" + encodeURI(window.location.href);
				}

				if (res.status == 403) {
					window.alert("FORBIDDEN");
					window.location.href = "/";
				}

				if (res.status == 200) {
					let json = res.json();
					if (json.error) {
						throw new Error("Unknown Error");
					} else {
						xitems[idx].hidden_success = true;
						success++;
					}
				} else {
					throw new Error("Unknown Error");
				}
			} catch (err) {
				xitems[idx].hidden_error = true;
				error++;
			}
		}

		setProgress(false);

		let text = `${success} Data berhasil disimpan`;

		if (error > 0) {
			text += `, ${error} Gagal`;
		}
		console.log("log", xitems);

		setItems(xitems);
		window.alert(text);
	};
	const processFileUpload = (fs) => {
		if (fs[0]) {
			const f = fs[0];

			const reader = new FileReader();

			reader.onabort = () => console.log("file reading was aborted");
			reader.onerror = () => console.log("file reading has failed");
			reader.onload = () => {
				// Do whatever you want with the file contents
				const data = reader.result;

				const workbook = new Excel.Workbook();
				workbook.xlsx.load(data).then((wb) => {
					const ws = wb.worksheets[0];

					let y = 5;

					let items = [];
					while (1) {
						const row = ws.getRow(y).values;

						console.log(row);

						if (!row) {
							console.log("break0");
							break;
						}

						if (!row[2]) {
							console.log("break1");
							break;
						}

						let i = processRow(row);

						if (i) {
							items.push(i);
						}

						y++;
						// if (y > 106) {
						// 	console.log('break3')
						// 	break;
						// }
					}

					setItems(items);
				});
			};
			reader.readAsArrayBuffer(f);
		}
	};

	const accept = ".xlsx";

	return (
		<>
			<div
				style={{
					padding: 8,
					display: "flex",
					backgroundColor: "#005e11",
					color: "white",
					fontSize: "200%",
					alignItems: "center",
				}}
			>
				<div>
					<Link
						to="../"
						style={{
							fontSize: "100%",
							fontWeight: "bold",
							display: "block",
							width: 24,
							height: 24,
							marginRight: 16,
							lineHeight: "24px",
							textAlign: "center",
							textDecoration: "none",
							color: "black",
							borderRadius: "100%",
							backgroundColor: "white",
						}}
					>
						&lsaquo;
					</Link>{" "}
				</div>

				<div>IMPORT</div>
			</div>

			<div style={{ padding: 16, overflowX: "auto" }}>
				{items.length > 0 && (
					<>
						<table
							width="100%"
							cellPadding={10}
							cellSpacing={0}
							className="t_daftar"
							style={{ textAlign: "right" }}
						>
							<thead style={{ backgroundColor: "#eee" }}>
								<tr style={{ textAlign: "center" }}>
									<td style={{ textAlign: "center" }}>No</td>

									<td style={{ textAlign: "center" }}>NISN</td>

									<td style={{ textAlign: "center" }}>Nama</td>
									<td style={{ textAlign: "center" }}>TTL</td>
									<td>JK</td>
									<td style={{ textAlign: "center" }}>Kelas</td>
									<td style={{ textAlign: "center" }}>Asal Sekolah</td>
									<td style={{ textAlign: "center" }}>Keterangan</td>
									<td style={{ textAlign: "center" }}>Link</td>
								</tr>
							</thead>
							<tbody>
								{items.map((i, idx) => {
									console.log("f", i);

									let lulus = true;

									if (
										i.lulus &&
										i.lulus.toUpperCase &&
										i.lulus.toUpperCase().indexOf("T") > -1
									)
										lulus = false;

									let jk = "L";

									if (
										i.jk &&
										i.jk.toUpperCase &&
										i.jk.toUpperCase().indexOf("P") > -1
									)
										jk = "P";

									return (
										<tr
											key={i.nisn}
											style={{ color: i.hidden_error ? "red" : "" }}
										>
											<td style={{ textAlign: "center" }}>{idx + 1}</td>
											<td style={{ textAlign: "center" }}>{i.nisn}</td>
											<td style={{ textAlign: "left" }}>{i.nama}</td>
											<td style={{ textAlign: "center" }}>
												{i.tmp_lahir} <br />
												{i.tgl_lahir}
											</td>
											<td style={{ textAlign: "center" }}>{jk}</td>
											<td style={{ textAlign: "center" }}>{i.kelas}</td>
											<td style={{ textAlign: "center" }}>{i.jurusan}</td>
											<td style={{ textAlign: "center", whiteSpace: "nowrap" }}>
												{!lulus ? (
													<span
														style={{
															color: "white",
															background: "red",
															borderRadius: 4,
															padding: 5,
														}}
													>
														TIDAK LULUS
													</span>
												) : (
													<span
														style={{
															color: "white",
															background: "#3BD144",
															borderRadius: 4,
															padding: 5,
														}}
													>
														{" "}
														LULUS
													</span>
												)}
												{/* <br />{" "}
	<a href={i.link} target="_blank">
	{i.link}
	</a> */}
											</td>
											<td style={{ textAlign: "left" }}>
												<a href={i.link} target="_blank">
													{i.link}
												</a>
											</td>
										</tr>
									);
								})}
							</tbody>
						</table>
						<div style={{ margin: 20, textAlign: "center" }}>
							<button
								onClick={() => setItems([])}
								variant="contained"
								size="large"
								disableElevation
								style={{
									padding: 8,
									color: "white",
									backgroundColor: "#AFB0B0",
									borderRadius: 5,
									border: 0,
								}}
							>
								Reset
							</button>
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
							<button
								onClick={() => doSubmit()}
								variant="contained"
								size="large"
								disableElevation
								// color="primary"
								style={{
									padding: 8,
									color: "white",
									backgroundColor: "green",
									borderRadius: 5,
									border: 0,
								}}
							>
								Simpan
							</button>
						</div>
					</>
				)}

				{items.length == 0 && (
					<>
						<p>
							Gunakan{" "}
							<a
								href={template}
								target="_blank"
								rel="noreferrer"
								style={{ color: "#0d6efd", textDecoration: "underline" }}
							>
								template terlampir
							</a>
							, kemudian unggah berkas untuk import
						</p>

						<Dropzone
							accept={accept}
							maxSize={10 * 1024 * 1024}
							multiple={false}
							onDrop={(f) => {
								processFileUpload(f);
							}}
						>
							{({ getRootProps, getInputProps }) => (
								<div
									{...getRootProps({})}
									style={{
										height: 150,
										border: "3px dashed #c0c0c0",
										overflow: "hidden",
										borderRadius: 10,
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
									}}
								>
									<input {...getInputProps()} />
									<div
										style={{
											color: "#c0c0c0",
											textAlign: "center",
											width: "100%",
											margin: 5,
										}}
									>
										<div style={{ fontSize: "120%" }}>
											{" "}
											Drag &amp; Drop atau Pilih Berkas{" "}
										</div>
									</div>
								</div>
							)}
						</Dropzone>
					</>
				)}

				{submitProgress !== false && (
					<div
						style={{
							zIndex: 99,
							backdropFilter: "blur(2px)",
							position: "fixed",
							top: 0,
							bottom: 0,
							right: 0,
							left: 0,
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
						}}
					>
						<div>
							<div className="spinner">
								<div className="bounce1"></div>
								<div className="bounce2"></div>
								<div className="bounce3"></div>
							</div>
							<br />
							<br />
							<br />
							<div
								style={{ textAlign: "center" }}
							>{`Menyimpan... (${submitProgress.progressCurrent} / ${submitProgress.progressTotal})`}</div>
							<div
								style={{
									width: 300,
									position: "relative",
									margin: 10,
									height: 10,
									borderRadius: 10,
									border: "1px solid #1E6887",
								}}
							>
								<div
									style={{
										width: `${submitProgress.progress}%`,
										borderRadius: 10,
										height: 10,
										background: "rgb(6, 109, 153)",
									}}
								></div>
							</div>
						</div>
					</div>
				)}
			</div>
		</>
	);
}
